module.exports = __webpack_public_path__ + "static/media/tip_text_dog_chewable_fr.f2da2f15.svg";